"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUSINESS_MAX_NAMES_PER_FORWARDING = exports.DPAG_MAX_NAMES_PER_FORWARDING = exports.CUSTOMER_MAX_NAMES_PER_FORWARDING = void 0;
exports.CUSTOMER_MAX_NAMES_PER_FORWARDING = 5;
exports.DPAG_MAX_NAMES_PER_FORWARDING = 12;
exports.BUSINESS_MAX_NAMES_PER_FORWARDING = 1;
//# sourceMappingURL=constants.js.map